import AdminSubHeader from "@legacy-components/layouts/partials/AdminSubheader";
import { selectEvent } from "@legacy-redux/preferences/selectors";
import {
  approveSafetyQuestionAnswer,
  getSafetyQuestionAnswersForApproval,
  rejectSafetyQuestionAnswer
} from "@legacy-services/api/safetyQuestions";
import { useEffect, useState } from "react";
import { connect } from "react-redux";

type Props = {
  event: any;
};

function SafetyQuestionAnswersReview({ event }: Props) {
  const [answers, setAnswers] = useState([]);

  const [answerStatusFilter, setAnswerStatusFilter] = useState('unhandled');

  async function fetchData() {
    const response = await getSafetyQuestionAnswersForApproval(event.id, answerStatusFilter);
    setAnswers(response.data);
  }

  async function approve(eventId: any, answerId: any) {
    await approveSafetyQuestionAnswer(eventId, answerId);
    fetchData();
  }

  async function reject(eventId: any, answerId: any) {
    await rejectSafetyQuestionAnswer(eventId, answerId);
    fetchData();
  }

  useEffect(() => {
    fetchData();
  }, [event, answerStatusFilter]);

  return (<div>
    <AdminSubHeader
      title="Safety Question Answers Needing Approval"
      key="subheader"
      breadcrumbs={[]}
    />
    <div className="listview m-portlet">
      <div className="m-portlet__head">
        <div className="row">
          <div className="filter filter-select col-xl-6">
            <div className="form-group m-form__group">
              <select
                className="form-control m-input"
                value={answerStatusFilter ?? ''}
                onChange={(e) => setAnswerStatusFilter(e.target.value)}
              >
                <option value="unhandled">Unhandled</option>
                <option value="approved">Approved</option>
                <option value="rejected">Rejected</option>
              </select>
            </div>
          </div>
        </div>
      </div>
      <div className="m-portlet__body">
        <table className="table m-table m-table--head-separator-success">
          <thead>
            <tr>
              <th>Company</th>
              <th>Question</th>
              <th>Answer</th>
              <th>Status</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
          {answers.map((answer: any) => (
            <tr key={answer.id}>
              <td>
                {answer.registration.company.name}
              </td>
              <td>
                {answer.safetyQuestion.question}
              </td>
              <td>
                {(answer.file) && (
                    <a className="text-primary" target="_blank" href={answer.file}>Download File</a>
                  )}

                  {(!answer.file) && (
                    <div>{answer.answer}</div>
                  )}
                </td>
                <td>
                  {answer.status}
                </td>
                <td className="flex items-end justify-content-end">
                  {(!answer.approved) && <button
                    className="btn btn-outline-success m-btn btn-sm  m-btn--icon m--margin-left-5"
                    onClick={() => approve(event.id, answer.id)}
                  >
                    <span>
                      <i className="la la-check"/>
                      <span>Approve</span>
                    </span>
                  </button>}
                  {(!answer.rejected) && <button
                    className="btn btn-outline-danger m-btn btn-sm  m-btn--icon m--margin-left-5"
                    onClick={() => reject(event.id, answer.id)}
                  >
                    <span>
                      <i className="la la-close"/>
                      <span>Reject</span>
                    </span>
                  </button>}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>

  </div>);
}

const mapStateToProps = (state: any) => ({
  event: selectEvent(state),
});

export default connect(mapStateToProps)(SafetyQuestionAnswersReview);